import {Stack, Typography, Button, Divider, useTheme} from '@mui/material'
import AppLoadingButton from "@/components/mui/LoadingButton";
import { getWithdrawDetail } from '@/services/user'
import { useRequest } from "ahooks";
import {getUrlParams} from "@/utils/utils.js";
import React, {useEffect} from "react";
import RpIcon from "@/components/RpIcon";
import AssetsService from "@/services/assets";
import useRenders from "@/hook/useRenders";
import {useNavigate} from "react-router-dom";
import {WITHDRAW_STATUS} from "@/constant/Constant.ts";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
import {useTranslation} from "react-i18next";
import CountUp from "react-countup";
import CopyButton from "@/components/CopyButton";
import {toListItemDateString} from "@/utils/dateUtils";
import dayjs from "dayjs";
import RouteConstant from "@/constant/RouteConstant";
import {enqueueSnackbar} from "notistack";
import { useConfirm } from "material-ui-confirm";
import StatusLabel from "@/components/StatusLabel";

const WithdrawDetail = () => {
  const sn = getUrlParams('sn')
  const navigate = useNavigate();
  const {t} = useTranslation();
  const { renderWithdrawStatus } = useRenders();
  const theme = useTheme();
  const confirm = useConfirm();
  const getWithdrawDetailReq = useRequest(async () => {
    const res = await getWithdrawDetail({sn})
    return res
  })

  const cancelOrderReq = useRequest(async () => {
    const res = await AssetsService.cancelWithdrawOrder({
        sn,
      });
    return res
  }, { manual: true })

  // useEffect(() => {
  //   getWithdrawDetailReq.runAsync()
  // }, [])

  const cancelOrder = () => {
    confirm({ description: t('cancel_withdraw_order_confirm') }).then(() => {
      cancelOrderReq.runAsync().then(() => {
        enqueueSnackbar(t('cancel_withdraw_order_success'), { variant: 'success' })
        navigate(RouteConstant.WITHDRAW_LIST, { replace: true })
      })
    })
  }

  return (<>
    <Stack direction="column"
    sx={theme => {
      return {
        width: '100%',
        flex: 1,
        height: '100%',
        // paddingTop: '24px',
      }
    }}
    >
      <Stack
        sx={{ padding: '0px 0px 32px 0px', width: '100%' }}
        direction="column" justifyContent="space-between" alignItems="center">
        <SimpleHeader
          backEnable
          title={t('withdraw_detail')}
        />
        <Stack direction="row" justifyContent="space-between" sx={{width: '100%', padding: '0 16px'}}>
          <Stack>
            <Typography fontSize={'13px'} color="textSecondary">{t('amount')}</Typography>
            <Stack direction={'row'} gap={'6px'} sx={{ alignItems: 'baseline' }}>
              <Typography fontSize={'32px'} fontWeight={700}>-{getWithdrawDetailReq?.data?.actualAmount} </Typography>
              <Typography fontSize={'14px'} fontWeight={500}>{getWithdrawDetailReq?.data?.varietyCode.toUpperCase()}</Typography>
            </Stack>
            <StatusLabel status={getWithdrawDetailReq?.data?.status} type="detail" />
            {/*<Typography>{*/}
            {/*  renderWithdrawStatus(getWithdrawDetailReq?.data?.status)*/}
            {/*}</Typography>*/}
            {(getWithdrawDetailReq?.data?.status == WITHDRAW_STATUS.Pending
                || getWithdrawDetailReq?.data?.status == WITHDRAW_STATUS.Waiting) &&
              <Stack gap="4px" direction="row" alignItems="self-start" sx={{marginTop:'10px'}} className={'alert-warm-info'}>
                <RpIcon icon="info" size={16}/>
                <Typography fontSize={'12px'}>
                  {t("withdraw_duration_tip")}
                </Typography>
            </Stack>}
          </Stack>
          <img src="/images/withdraw-detail.svg"/>
        </Stack>
        {(getWithdrawDetailReq?.data?.status == WITHDRAW_STATUS.Fail) &&
          <Typography sx={{ width: '100%', paddingLeft: '16px', textAlign: 'left' }}>
          {getWithdrawDetailReq?.data?.auditInfo || '--'}
        </Typography>}
      </Stack>
      <Divider sx={{borderWidth: '6px', borderColor: theme.palette.background.paper}} />
      <Stack gap={'20px'} sx={{flex: 1, padding: '20px 16px 24px 16px' }}>
        <Typography fontSize={'16px'} fontWeight={700}>
          {t('transaction_details')}
        </Typography>
        <Stack gap={'6px'}>
          <Typography fontSize={'12px'} color="textSecondary">{t('network')}</Typography>
          <Typography fontSize={'14px'} fontWeight={500}>{getWithdrawDetailReq?.data?. coinDisplayName}</Typography>
        </Stack>
        <Stack gap={'6px'}>
          <Typography fontSize={'12px'} color="textSecondary">{t('address')}</Typography>
          <Stack direction="row" alignItems="center">
            <Typography fontSize={'14px'} fontWeight={500} sx={{wordBreak: 'break-all'}}>{getWithdrawDetailReq?.data?. withdrawAddress}</Typography>
            <CopyButton value={getWithdrawDetailReq?.data?.withdrawAddress} size={16}/>
          </Stack>
        </Stack>
        <Stack gap={'6px'}>
          <Typography fontSize={'12px'} color="textSecondary">{t('amount')}</Typography>
          <Typography  fontSize={'14px'} fontWeight={500}>{getWithdrawDetailReq?.data?. amount} {getWithdrawDetailReq?.data?.varietyCode.toUpperCase()}</Typography>
        </Stack>
        <Stack gap={'6px'}>
          <Typography fontSize={'12px'} color="textSecondary">{t('fee')}</Typography>
          <Typography  fontSize={'14px'} fontWeight={500}>{getWithdrawDetailReq?.data?.fee} {getWithdrawDetailReq?.data?.varietyCode.toUpperCase()}</Typography>
        </Stack>
        <Stack gap={'6px'}>
          <Typography fontSize={'12px'} color="textSecondary">{t('date')}</Typography>
          <Typography  fontSize={'14px'} fontWeight={500}>{dayjs(getWithdrawDetailReq?.data?. createTime).format('D/MM/YYYY HH:mm:ss')}</Typography>
        </Stack>
        <Stack gap={'6px'}>
          <Typography fontSize={'12px'} color="textSecondary"> {t('order_id')}</Typography>
          <Stack direction="row" alignItems="center">
            <Typography fontSize={'14px'} fontWeight={500}>{getWithdrawDetailReq?.data?. sn}</Typography>
            <CopyButton value={getWithdrawDetailReq?.data?.sn} size={16}/>
          </Stack>
        </Stack>
      </Stack>
      {getWithdrawDetailReq?.data &&
        <Stack
          sx={theme => ({
          padding: '0 16px 20px'
        })}
        >
          {getWithdrawDetailReq?.data?.status != WITHDRAW_STATUS.Pending && <AppLoadingButton
              size={'large'}
          sx={theme => ({
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
          })}
          fullWidth variant="contained" target="_blank"
          rel="noopener noreferrer"
          href={getWithdrawDetailReq?.data?.txLink}>{t('view_on_blockchain_explorer')}</AppLoadingButton>}
          {getWithdrawDetailReq?.data?.status == WITHDRAW_STATUS.Pending && <AppLoadingButton
              size={'large'}
            sx={theme => ({
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
            })}
            fullWidth variant="contained"
            loading={cancelOrderReq.loading}
            onClick={() => { cancelOrder() }}
           >{t('cancel')}</AppLoadingButton>}
      </Stack>
      }
    </Stack>
  </>)
}

export default WithdrawDetail